import ConstantFunctions from "../../../utils/constants_functions";

export const ReceivedAmountRenderer = (props: any) => {
  const constantFunctions = new ConstantFunctions();

  const { data } = props;
  const amount =
    data.ledger === "CR" ? data.settledAmountReceived : data.settledAmountSent;

  return (
    <div className="flex flex-row items-center gap-[4px] h-full">
      <img src={data.tci} height={10} width={10} alt="currency icon" />
      <p>{constantFunctions.formatAmount(amount ?? 0)}</p>
    </div>
  );
};
